// Path: ./src/utils/preference/watchItemPayload.ts
import { GfPreferenceWatchItem } from "@swagger/typescript-fetch-goflyer";

export type WatchItemRow = GfPreferenceWatchItem;

export interface WatchItemFormState {
  name: string;
}

export const emptyWatchItemFormState = (): WatchItemFormState => ({ name: "" });

export const watchItemToFormState = (
  watchItem: WatchItemRow,
): WatchItemFormState => ({ name: watchItem.name ?? "" });

export const buildWatchItemPayload = (
  form: WatchItemFormState,
): Record<string, unknown> => ({ name: form.name.trim() });
